// extracted by mini-css-extract-plugin
module.exports = {"resetWrapper":"SidebarColumns_resetWrapper__2l3Z3"};